import { render, staticRenderFns } from "./TranslateText.vue?vue&type=template&id=9bd9e378&scoped=true&"
import script from "./TranslateText.vue?vue&type=script&lang=js&"
export * from "./TranslateText.vue?vue&type=script&lang=js&"
import style0 from "./TranslateText.vue?vue&type=style&index=0&id=9bd9e378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd9e378",
  null
  
)

export default component.exports